import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Button,
    Col,
    Row
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import manualIcon from "../../assets/svg/looking-glass.svg";
import starIcon from "../../assets/svg/success-star.svg";
import { handleReInitiateCredit, handleSubmitCreditExam } from "../../store/actions/credit";
import { hideModal } from "../../store/actions/display";
import { SelectField } from "../../validation/ReduxFormInput";
import { AsyncButton, FormAsyncButton } from "../controls/buttons/AsyncButton";




class TransUnionExam extends Component {
    render() {
        const {handleSubmit, _handleSubmitCreditExam, _handleReInitiateCredit, _hideModal, exam, evaluation, modal: {tenantId, key}, submitting} = this.props;
        return (
            <div>
                {
                    evaluation === 'Pass' ? (
                        <div className="center">
                            <img className="center-block"
                                 width="50%"
                                 style={{maxWidth: '120px', paddingTop: '18px', paddingBottom: "16px"}}
                                 src={starIcon}
                                 alt="Success"/>

                            <h2 className="text-center">Credit Confirmed</h2>
                            <div style={{maxWidth: '560px', margin: '25px auto 25px auto'}}>
                                <p>
                                    Thank you for verifying your credit. We take your privacy very seriously and never store any of your personal information. If you have questions about how credit reports work, feel free to reach out at any time.
                                </p>
                                <p>
                                    If the person for whom you're guaranteeing is still looking for a home in 30 days, you'll need to come back to this page to re-verify your credit. Don't worry, it won't impact your credit score.
                                </p>
                            </div>
                            <Row>
                                <Col>
                                    <Button color="success" outline onClick={_hideModal}>Finish Up</Button>
                                </Col>
                            </Row>
                        </div>
                    ) : evaluation === 'Fail' ? (
                        <div className="center">
                            <h2>Incorrect Answers</h2>
                            <div style={{maxWidth: '560px', margin: '25px auto 25px auto'}}>
                                <p>The answers you provided to verify your identity were incorrect. Click the button below to try again.</p>
                                <p><strong>If you answer these questions incorrectly a few more times, you will need to contact TransUnion directly to verify your credit report.</strong></p>
                                <div className="center">
                                    <AsyncButton task={() => _handleReInitiateCredit(tenantId, key)} color="info" className="mt-2 mb-2" outline>Try Again</AsyncButton>
                                </div>
                                <p className="text-center">
                                    <small>If you have any questions for PolyRents, we can always be reached at <a
                                        href="mailto:hello@polyrents.com">hello@polyrents.com</a></small>
                                </p>
                            </div>
                        </div>
                    ) : evaluation === 'Manual' ? (
                        <div className="center">
                            <img className="center-block" width="50%"
                                 style={{maxWidth: '120px', paddingTop: '18px', paddingBottom: '16px'}} src={manualIcon}
                                 alt="Verification Issue"/>

                            <h2>Manual Verification Required</h2>
                            <div style={{maxWidth: '560px', margin: '25px auto 25px auto'}}>
                                <p>It looks like TransUnion wasn't able to automatically check your credit. We know it may be a
                                    little bit frustrating, but you'll need to call them to do a manual verification. It's not
                                    as much of a pain as it seems; TransUnion has an entire department dedicated to making the
                                    process as quick and painless as possible (this happens quite a bit).</p>
                                <p className="text-center">Their phone number is:</p>
                                <h4 className="text-center" style={{marginTop: '10px', marginBottom: '50px'}}>(833) 458-6338</h4>
                                {exam.screening_request_id && <p>If they ask for a "screening request ID", it's <b>{exam.screening_request_id}</b>.</p>}
                                <p className="text-center">
                                    <small>If you have any questions for PolyRents, we can always be reached at <a
                                        href="mailto:hello@polyrents.com">hello@polyrents.com</a></small>
                                </p>
                            </div>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit(_handleSubmitCreditExam)}>
                            <h5 className="text-center">
                                {
                                    evaluation === 'AdditionalQuestions'
                                    ?
                                    "Please answer a few more questions"
                                    :
                                    "Please answer a few questions to help verifiy your identity"
                                }
                            </h5>
                            <p className="text-center"><small>These questions and answers are provided directly by TransUnion</small></p>
                            <hr/>
                            {
                                exam.Questions && exam.Questions.map(function (question, i) {
                                    return (
                                        <Row key={i}>
                                            <Col>
                                                <Field name={question.Id + ".SelectedAnswerId"} label={question.Text} component={SelectField} defaultValue={"default"}
                                                       options={[
                                                           {
                                                               value: "default",
                                                               name: "Select"
                                                           },
                                                           ...question.Answers.map(function (answer, i) {
                                                               return {
                                                                   value: answer.Id,
                                                                   name: answer.Text
                                                               };
                                                           })]}/>
                                            </Col>
                                        </Row>
                                    );
                                })
                            }

                            <div className="center">
                                <FormAsyncButton type="submit" color="success" acting={submitting}>Submit</FormAsyncButton>
                            </div>
                        </form>
                    )
                }
            </div>
        );
    }
}

// const validate = values => {
//     const errors = {};
//
//     for (let value in values) {
//         if (values.hasOwnProperty(value)) {
//             // console.log(values[value]);
//         }
//     }
//
//     return errors;
// };

TransUnionExam = reduxForm({
    form: 'tu-verify'
})(TransUnionExam);

const mapStateToProps = (state) => ({
    exam: state.credit.exam,
    idmaStatus: state.tenant.idmaStatus,
    evaluation: state.credit.exam.Evaluation,
    modal: state.display.modals.find((i) => i.id === 'tu_exam_modal'),
});

const mapDispatchToProps = (dispatch) => {
    return {
        _handleSubmitCreditExam(data) {
            return dispatch(handleSubmitCreditExam(data));
        },
        _handleReInitiateCredit(tenantId, key) {
            return dispatch(handleReInitiateCredit(tenantId, key));
        },
        _hideModal() {
            return dispatch(hideModal('tu_exam_modal'));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransUnionExam);



// WEBPACK FOOTER //
// ./src/components/credit/TransUnionExam.js